import { Button } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import { SsoConnector } from "src/pages/Authentication/ssoConnector";

type SsoConnectorButtonProps = {
    connector: SsoConnector;
    label: string;
    onClick: () => void;
    variant: "primary" | "secondary";
    disabled?: boolean;
};
export const SsoConnectorButton = (props: SsoConnectorButtonProps) => {
    const { connector, label, onClick, variant, disabled = false } = props;
    const theme = useTheme();
    const [logoState, setLogoState] = useState({ logo: connector.logo, isBroken: false });

    if (logoState.logo !== connector.logo) {
        setLogoState({ logo: connector.logo, isBroken: false });
    }

    const displayLogo = connector.logo !== undefined && logoState.isBroken === false;

    return (
        <Button
            variant={variant === "primary" ? "primary" : "ternary"}
            onClick={onClick}
            disabled={disabled}
            sx={{
                width: "100%",
                gap: theme.spacing(1),
                height: "auto",
                minHeight: theme.spacing(5),
                paddingBlock: theme.spacing(1),
            }}
        >
            {displayLogo && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: theme.spacing(5),
                        height: theme.spacing(2.5),
                        flexShrink: 0,
                    }}
                >
                    <Box
                        component="img"
                        alt=""
                        src={connector.logo}
                        onError={() => setLogoState({ logo: connector.logo, isBroken: true })}
                        sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                </Box>
            )}
            {label}
        </Button>
    );
};
